/* eslint-disable simple-import-sort/imports */
/* eslint-disable react/destructuring-assignment */
import { Checkbox, Form, Input, message } from 'antd';
import { useEffect, useState } from 'react';
import { AiOutlineLock, AiOutlineMail } from 'react-icons/ai';
import { BsBuilding } from 'react-icons/bs';
import { HiOutlineArrowLeft, HiOutlineArrowRight } from 'react-icons/hi';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { VerificacaoCodigo } from './VerificacaoCodigo';
import { AuthLayout } from '../../../components/AuthLayout';
import { useAuth } from '../../../hooks/useAuth';
import { useQuery } from '../../../hooks/useQuery';
import * as authRules from '../../../rules/auth';
import {
  BackButton,
  CompanyArrow,
  CompanyCard,
  CompanyIcon,
  CompanyInfo,
  CompanyList,
  CompanyName,
  CompanySelectSubtitle,
  CompanySelectTitle,
  CompanySelectWrapper,
  FormWrapper,
  LoginCard,
  LoginSubtitle,
  RememberRow,
  SubmitButton,
} from './styles';

export const Login = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const location = useLocation();
  const { signIn, concluirSignIn, signInByApiToken } = useAuth();
  const query = useQuery();
  const [hasMoreThanOneCustomer, setHasMoreThanOneCustomer] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [desafio, setDesafio] = useState(null);

  useEffect(() => {
    if (query.has('error')) {
      message.error('Necessário refazer o login!');
    }
  }, []);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const resultado = await signIn({
        email: values.email.trim(),
        password: values.password,
      });

      setIsLoading(false);

      if (resultado.desafio) {
        setEmail(values.email.trim());
        setDesafio(resultado.desafio);
        return;
      }

      seguirDepoisDoLogin(resultado);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const seguirDepoisDoLogin = (resultado) => {
    if (resultado.customers) {
      setHasMoreThanOneCustomer(true);
      setCustomers(resultado.customers);
      return;
    }

    const prevPath = location?.state?.prevPath;

    history.push(prevPath || '/');
  };

  const handleCodigoConfirmado = async (resposta) => {
    const resultado = await concluirSignIn(email, resposta.data, resposta.dispositivo);
    setDesafio(null);
    seguirDepoisDoLogin(resultado);
  };

  const handleVoltarDoCodigo = (mensagem) => {
    setDesafio(null);
    form.setFieldsValue({ email, password: '' });
    if (mensagem) message.error(mensagem);
  };

  const handleSignInByApiToken = async (token) => {
    signInByApiToken(token);

    const prevPath = location?.state?.prevPath;

    history.push(prevPath || '/');
  };

  const handleEmailChange = (e) => {
    const value = e.target.value.trim();
    setEmail(value);
    form.setFieldsValue({ email: value });
  };

  const handleEmailBlur = async () => {
    const emailValue = form.getFieldValue('email');
    if (!emailValue) {
      form.setFields([
        {
          name: 'email',
          errors: ['Por favor, insira seu e-mail!'],
        },
      ]);
    } else if (!/\S+@\S+\.\S+/.test(emailValue)) {
      form.setFields([
        {
          name: 'email',
          errors: ['O e-mail não é válido!'],
        },
      ]);
    } else {
      form.setFields([
        {
          name: 'email',
          errors: [],
        },
      ]);
    }
  };

  return (
    <AuthLayout>
      {desafio && !hasMoreThanOneCustomer ? (
        <VerificacaoCodigo
          desafio={desafio}
          onConfirmado={handleCodigoConfirmado}
          onVoltar={handleVoltarDoCodigo}
        />
      ) : hasMoreThanOneCustomer ? (
        <CompanySelectWrapper>
          <CompanySelectTitle>Selecione uma empresa</CompanySelectTitle>
          <CompanySelectSubtitle>
            Você tem acesso a múltiplas empresas
          </CompanySelectSubtitle>
          <CompanyList>
            {customers.map((customer) => (
              <CompanyCard
                key={customer.id || customer.api_token}
                onClick={() => handleSignInByApiToken(customer.api_token)}
              >
                <CompanyIcon>
                  <BsBuilding />
                </CompanyIcon>
                <CompanyInfo>
                  <CompanyName>{customer.name?.toLowerCase()}</CompanyName>
                </CompanyInfo>
                <CompanyArrow>
                  <HiOutlineArrowRight />
                </CompanyArrow>
              </CompanyCard>
            ))}
          </CompanyList>
          <BackButton
            onClick={() => {
              setHasMoreThanOneCustomer(false);
              setCustomers([]);
            }}
          >
            <HiOutlineArrowLeft />
            Voltar para login
          </BackButton>
        </CompanySelectWrapper>
      ) : (
        <LoginCard>
          <LoginSubtitle>Digite suas credenciais para acessar o sistema</LoginSubtitle>
          <FormWrapper>
            <Form
              id="loginForm"
              form={form}
              onFinish={handleSubmit}
              initialValues={{ email, remember: true }}
              layout="vertical"
            >
              <Form.Item name="email" label="Email">
                <Input
                  prefix={<AiOutlineMail />}
                  placeholder="seu@email.com"
                  size="large"
                  onChange={handleEmailChange}
                  onBlur={handleEmailBlur}
                />
              </Form.Item>

              <Form.Item name="password" label="Senha" rules={authRules.password}>
                <Input.Password
                  prefix={<AiOutlineLock />}
                  placeholder="Digite sua senha"
                  size="large"
                />
              </Form.Item>

              <RememberRow>
                <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>Lembrar-me</Checkbox>
                </Form.Item>
                <Link to="/esqueci-a-senha">Esqueceu a senha?</Link>
              </RememberRow>

              <SubmitButton type="submit" disabled={isLoading}>
                {isLoading ? 'Entrando...' : 'Entrar'}
                {!isLoading && <HiOutlineArrowRight />}
              </SubmitButton>
            </Form>
          </FormWrapper>
        </LoginCard>
      )}
    </AuthLayout>
  );
};
